import {ElementsTree} from "../../model/ElementsTree";
import {Graph} from "../../model/Graph";
import {Playshot} from "../../model/Playshot";
import {compareCommands} from "./diff/commands/compare-commands";
import {compareEvents} from "./diff/events/compare-events";
import {compareInformation} from "./diff/information/compare-information";
import {comparePages} from "./diff/pages/compare-pages";
import {PlayshotChanged} from "./diff/PlayshotChanged";

export const comparePlayshots = (oldPlayshot: Playshot, newPlayshot: Playshot, graph: Graph, elementsTree: ElementsTree): PlayshotChanged[] => {
  const changeSet: PlayshotChanged[] = [];

  changeSet.push(...comparePages(oldPlayshot, newPlayshot, graph, elementsTree));
  changeSet.push(...compareCommands(oldPlayshot, newPlayshot, graph, elementsTree));
  changeSet.push(...compareEvents(oldPlayshot, newPlayshot, graph, elementsTree));
  changeSet.push(...compareInformation(oldPlayshot, newPlayshot, graph,elementsTree));

  return changeSet;
}
